@if(resource()){
<udex-tile class="resource-tile d-flex flex-column flex-grow-1" interactive [href]="resource().value" target="_blank"
  [accessibleName]="resource().text">
  <dcp-product-tile-content [resource]="resource()"></dcp-product-tile-content>
</udex-tile>
}
